import { apiSlice } from './apiSlice';

/**
 * Payout method on file (Payment Verification).
 *
 *   GET  /v2/get/payment-verification/    → { verification_type, bank_wire,
 *                                             is_verified, status, details }
 *   POST /v2/update/payment-verification/ ← { verification_type, bank_wire?,
 *                                             ...details }
 *
 * `verification_type` names the method ("RISE", "WISE", "Bank Wire"); for Bank
 * Wire, `bank_wire` is the rail ("ACH", "SWIFT") and null otherwise. `details`
 * carries the rows keyed on the form's field names:
 *
 *   RISE   { rise_email }
 *   WISE   { wise_email, wise_tag }
 *   ACH    { account_name, ach_routing_number, account_number, account_type,
 *            country, city, address, postal_code }
 *   SWIFT  { account_name, swift_bic_code, account_number (the IBAN),
 *            account_type, country, city, address, postal_code }
 *
 * `country` is a name ("India"); Bank Wire's `details` also repeat the rail
 * and status, which the page ignores. The update takes the same rows flat,
 * beside `verification_type` and `bank_wire`, rather than under `details`.
 */
export const paymentVerificationApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getPaymentVerification: builder.query({
      query: () => '/v2/get/payment-verification/',
      providesTags: ['PaymentVerification'],
    }),

    updatePaymentVerification: builder.mutation({
      query: (body) => ({
        url: '/v2/update/payment-verification/',
        method: 'POST',
        body,
      }),
      /*
       * Write the saved method into the read as soon as the update succeeds,
       * so the page goes straight to its summary instead of flashing the form
       * again while the refetch is in flight; the refetch then brings the
       * server's own status.
       */
      async onQueryStarted(
        { verification_type, bank_wire = null, ...details },
        { dispatch, queryFulfilled },
      ) {
        try {
          await queryFulfilled;
        } catch {
          return;
        }
        dispatch(
          paymentVerificationApi.util.upsertQueryData('getPaymentVerification', undefined, {
            verification_type,
            bank_wire,
            is_verified: false,
            status: 'Pending',
            details,
          }),
        );
        dispatch(paymentVerificationApi.util.invalidateTags(['PaymentVerification']));
      },
    }),
  }),
});

export const { useGetPaymentVerificationQuery, useUpdatePaymentVerificationMutation } =
  paymentVerificationApi;
